import {Endpoint} from '@eryxcoop/appyx-comm';

export default class GetCustomerArticlePriceListEndpoint extends Endpoint {
  adaptValues(businessName) {
    return {
      'business_name': businessName
    }
  }
}